/**
 * Hand-written types matching the `wanderfit-api` OpenAPI spec as of 2026-04-20.
 *
 * Mirrors the generated Orval surface but with `readonly` properties and a
 * documented `FeatureFlagValueType` enum. The UI layer never imports the
 * generated surface directly — see CLAUDE.md → TD-07 for why.
 */

export const FeatureFlagValueType = {
  BOOLEAN: "BOOLEAN",
  STRING: "STRING",
  NUMBER: "NUMBER",
  JSON: "JSON",
} as const;
export type FeatureFlagValueType = (typeof FeatureFlagValueType)[keyof typeof FeatureFlagValueType];

export type FeatureFlagValue = unknown;

export interface FeatureFlag {
  readonly id: string;
  readonly valueType: FeatureFlagValueType;
  readonly defaultValue: FeatureFlagValue;
  readonly value: FeatureFlagValue;
  readonly description: string;
  readonly isPublic: boolean;
  readonly createdAt: string;
  readonly updatedAt: string;
}

export interface FeatureFlagChange {
  readonly id: string;
  readonly flagId: string;
  readonly previousValue: FeatureFlagValue | null;
  readonly newValue: FeatureFlagValue;
  readonly changedBy: string | null;
  readonly reason: string | null;
  readonly changedAt: string;
}

export interface FeatureFlagDetail extends FeatureFlag {
  readonly lastChanges: readonly FeatureFlagChange[];
}

export interface FeatureFlagHistoryResponse {
  readonly items: readonly FeatureFlagChange[];
  readonly total: number;
}

export interface UpdateFeatureFlagInput {
  readonly value: FeatureFlagValue;
  readonly reason?: string;
}
